<template>
  <div style="padding-top:20PX;padding-bottom: 40PX;" :class="{'mobileCont': mobile == 1}">
      <div class="main">
        <div class="main-title">
            <span v-if="viewNum == 0">{{$t('home.help')}}</span>  
            <span v-if="viewNum == 1">{{$t('help.accountAppeal')}}</span>  
            <span v-if="viewNum == 2">{{$t('help.progressQuery')}}</span>
        </div>
        <div class="card-div" >
          <div v-if="viewNum ==0">
            <div  v-if="mobile == 0" style="float: left;width: 350PX;" v-on:click="goSteos"> 
                    <span class="card-title">{{$t('help.accountAppeal')}}</span>
                    <div class="card-on">
                    <h3>{{$t('help.findAccount')}}</h3>
                    <span>{{$t('help.submitApplications')}}</span>
                    <div>
                        <el-link class="back-link"   :underline="false" type="primary">{{$t('help.submitButton')}}</el-link>
                    </div>
                    </div>
                </div>
                <!-- 手机端 -->
                <div v-else class="mobileAccount" v-on:click="goSteos">
                  <h3>{{$t('help.accountAppeal')}}</h3>
                  <div class="link clearfix">
                    <h3>{{$t('help.findAccount')}}</h3>
                    <p>{{$t('help.submitApplications')}}</p>
                    <el-link class="back-link"   :underline="false" type="primary">{{$t('help.submitButton')}}</el-link>
                  </div>
                </div>
          </div>
                 
                <!-- <div style="float: left;width: 30%;margin-left:5%" v-on:click="goQuery">
                    <span>申诉进度查询</span>
                    <div class="card-on">
                    <h3>查询进度</h3>
                    <span>提交申诉后点此查询进度。</span>
                    <div>
                        <el-link class="back-link"  :underline="false" type="primary">查询</el-link>
                    </div>
                    </div>
                </div> -->
            <vue-steps v-if="viewNum ==1" :mobile='mobile'></vue-steps>
            <!-- <vue-query v-if="viewNum ==2"></vue-query> -->
        </div>
      </div>
        <span class="backSpan" v-if="$route.name === 'Help' && viewNum == 0"  @click="back">
          <img class="back-img" src="../assets/backone.png" alt="">
          <span>
                {{$t('help.backPrevious')}}
          </span>
       </span>
  </div>
</template>

<script>
import steps from "./cards/steps";
import query from "./cards/query";

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    "vue-steps": steps,
    "vue-query": query,
  },
  props: ['mobile'],
  data() {
    //这里存放数据
    return {
      viewNum: sessionStorage.getItem('isHelpView') ? sessionStorage.getItem('isHelpView') : 0
    };
  },
  //监听属性 类似于data概念
  computed: {
  },
  //监控data中的数据变化
  watch: {
  },
  //方法集合
  methods: {
    back(){
      this.$router.push('/')
    },
    goSteos(){
      this.viewNum =1 
      sessionStorage.setItem("isHelpView", 1);

    },
    goQuery(){
      this.viewNum =2
      sessionStorage.setItem("isHelpView", 2);


    },
    goBack() {
      this.$router.push("/");
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    window.addEventListener('setItem', ()=> {
      this.viewNum = sessionStorage.getItem('isHelpView');
    })
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped lang="scss">
.card-title{
  margin-bottom: 18PX;
  display: block;
  font-size: 18PX;
  font-weight: 700;
}
 .backSpan{
    display: block;
    cursor: pointer;
    color: #3E8EDE !important;
    padding: 0 14%;
    margin-top: 100PX;
    font-size: 16PX;
}
.back-img{
  margin-bottom: -4PX;
  width: 16PX;
  height: 16PX;
}
.card-div {
  margin-top: 30PX;
  padding: 0 14%;
  overflow: hidden;
  margin-bottom: 100PX;
}
.card-on > h3 {
  /* display: inline-block; */
  /* padding: 30PX 0PX 22PX 30PX; */
  text-align: center;
  padding-top: 30PX;
  padding-bottom: 22PX;
  font-size: 16PX;
}
.card-on > span {
  display: inline-block;
  padding: 0PX 30PX 30PX 40PX;
  text-align: left;
  font-size: 14PX;
}
.card-on > div {
  /* position: absolute; */
  bottom: 40PX;
  width: 100%;
  text-align: center;
  padding-bottom: 20PX;
}
.card-on {
  cursor: pointer;
  background-color: #fff;
  /* height: 290PX; */
  position: relative;
  border: 1PX solid #ddd;
  border-radius: 8PX;
}
.center{
    padding: 0 14%;
    height: 100%;
    width: 100%;
}
.lenovo {
    width: 107PX;
    vertical-align: middle;
    cursor: pointer;
}
.main {
  padding: 0PX;
  height: 100%;
}
.main-title > span{
    font-weight: 700;
    color: #666!important;
    // margin-top: 38PX!important;
    font-size: 18PX!important;

}
.main-title {
  line-height: 40PX;
  padding: 25PX 14% 45PX 14%;
  border-bottom: 1PX solid #ddd;
  background-color: #ffffff;
  height: 40PX;
  position: relative;
  overflow: hidden;
}
.el-footer {
  background-color: #000;
  position: fixed;
  bottom: 0 !important;
  width: 100%;
  height: 33PX;
  line-height: 33PX;
}
.back-link {
  font-size: 16PX;
  margin-right: 30PX;
}
.go-back {
  margin-right: 20PX;
  float: right;
  color: #3e8ede;
}

// 手机端
.mobileCont{
  .main-title{
    padding:15PX 25PX 35PX 25PX;
    height: 30px;
    line-height: 30px;
  }
  .card-div{
    padding:0 20PX;
  }
  .backSpan span{
    font-size: 16PX;
  }
}
.mobileAccount{
 
  h3{
    font-size: 20PX;
    line-height: 40PX;
  }
  .link{
    border:1PX solid #DDDDDD;
    border-radius: 4PX;
    padding: 20PX;
    margin-top: 10PX;
    p{
      font-size: 16PX;
    }
    .back-link{
      margin-left: 60PX;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/help.vue